<template>
  <div class="game-section-inner">
    <div class="assets-count" @click='togglePopup'>
      <v-alert
        class="assets-count-block"
        :class='[tier]'
      >
        <div class="inner-assets-count">
          <span class="achievement-label">{{ $t('dashboard.assets.score.widget.title') }}</span>
          <roller class='assets-count-value' :text='assetsFormatted' :transition='2' />
        </div>
      </v-alert>
    </div>
    <assets-count-details-popup
      :points='assetsFormatted'
      :tier='tier'
      :visible-popup='showPopup'
      :domains='domains'
      @clicked='togglePopup'
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Roller from 'vue-roller';
import { tierColors } from '@/constants/game';
import AssetsCountDetailsPopup from '@/components/popup/AssetsCountDetailsPopup.vue';

export default {
  name: 'DashboardAssetsCount',
  components: {
    AssetsCountDetailsPopup,
    Roller,
  },
  props: {
    domains: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      showPopup: false,
    };
  },
  computed: {
    ...mapGetters(['generalStatistics']),
    assets() {
      return this.calculateAssets;
    },
    assetsFormatted() {
      return this.assetsNumericValue > 9999 ? '9,999+' : this.assetsNumericValue.toLocaleString('en-US');
    },
    assetsNumericValue() {
      return parseInt(this.assets, 10);
    },
    tier() {
      if (this.assetsNumericValue < 31) return tierColors.blue;
      if (this.assetsNumericValue < 91) return tierColors.bronze;
      if (this.assetsNumericValue < 251) return tierColors.silver;
      if (this.assetsNumericValue < 1001) return tierColors.gold;
      if (this.assetsNumericValue < 2501) return tierColors.platinum;
      return tierColors.purple;
    },
    calculateAssets() {
      const discovery = Object.values(this.generalStatistics).map(statistics => statistics.discovery).filter(item => item);
      let amountSubdomains = 0;
      let amountHosts = 0;
      discovery.forEach(stats => {
        amountSubdomains += (stats.statistics?.data?.subdomains?.alive || 0);
        amountHosts += (stats.statistics?.data?.hosts?.total || 0);
      });
      return amountSubdomains + amountHosts;
    },
  },
  methods: {
    togglePopup() {
      this.showPopup = !this.showPopup;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.game-section-inner {
  display: flex;
}

.chart {
  display: flex;
  justify-content: center;
}

.assets-count {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: rem(35);
  margin-right: rem(5);
  &:hover {
    cursor: pointer;
  }
}

.achievement-label {
  color: #FFFFFF;
  font-family: $font-family-regular;
  opacity: 0.5;
  font-size: rem(12);
  letter-spacing: rem(1.1);
  line-height: rem(15);
}

.assets-count-block {
  border-radius: $radius-md;
  background-image: linear-gradient(135deg, #8F24D3 0%, #6A1B9A 100%);
  box-shadow: 0 4px 20px 0 rgba(143, 36, 211, 0.4) !important;
  margin-bottom: 0;
  padding: rem(10) rem(16);
  width: rem(204);
  height: rem(129);
  display: flex;
  flex-direction: column;
  justify-content: center;
  &.blue {
    background-image: linear-gradient(135deg, #4D9FEB 0%, #1976D2 100%);
    box-shadow: 0 4px 20px 0 rgba(77, 159, 235, 0.4) !important;
  }
  &.bronze {
    background-image: linear-gradient(135deg, #CD7F32 0%, #8B4513 100%);
    box-shadow: 0 4px 20px 0 rgba(205, 127, 50, 0.4) !important;
  }
  &.silver {
    background-image: linear-gradient(135deg, #C0C0C0 0%, #808080 100%);
    box-shadow: 0 4px 20px 0 rgba(192, 192, 192, 0.4) !important;
  }
  &.gold {
    background-image: linear-gradient(135deg, #FFD700 0%, #B8860B 100%);
    box-shadow: 0 4px 20px 0 rgba(255, 215, 0, 0.4) !important;
  }
  &.platinum {
    background-image: linear-gradient(135deg, #E5E4E2 0%, #A9A9A9 100%);
    box-shadow: 0 4px 20px 0 rgba(229, 228, 226, 0.4) !important;
  }
}
.assets-count-value{
  color: #FFFFFF;
  font-family: $font-family-black;
  font-size: rem(41);
  font-weight: 900;
  line-height: rem(50);
  letter-spacing: 0;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
}

.inner-assets-count {
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>
<style lang='scss'>
@import '~@/assets/styles/design-system';
.inner-assets-count {
  .roller {
    &__wrapper {
      margin-left: rem(-25) !important;
    }
    &__char {
      font-variant-numeric: tabular-nums;
      font-feature-settings: "tnum";
      min-width: 0.6em;
      text-align: center;
    }
  }
}
</style>
